import DisableEditIcon from '@components/Icons/DisableEditIcon';

import styles from './CardHeaderPictures.module.scss';

const PicturePreventOverrideIcon: React.FC<
  React.PropsWithChildren<{
    locked: boolean | undefined;
    position: 'top-left' | 'top-right' | 'bottom-right' | 'far-bottom-right';
  }>
> = ({ position, locked }) => {
  if (!locked) return null; // don't render if no lock
  return (
    <span className={styles['prevent-override-icon-container']} data-position={position}>
      <span>{locked ? <DisableEditIcon /> : null}</span>
    </span>
  );
};

export default PicturePreventOverrideIcon;
